// @flow
import _ from 'lodash';
import type { StopWordsState, StopWordsAction } from 'stores/flow-type/stop-words.type';

import {
  GET_STOP_WORDS_REQUEST,
  GET_STOP_WORDS_SUCCESS,
  GET_STOP_WORDS_FAILURE,
  UPDATE_STOP_WORDS_REQUEST,
  UPDATE_STOP_WORDS_SUCCESS,
  UPDATE_STOP_WORDS_FAILURE,
  VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_REQUEST,
  VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_SUCCESS,
  VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_FAILURE,
  IMPORT_FILE_STOP_WORDS_REQUEST,
  IMPORT_FILE_STOP_WORDS_SUCCESS,
  IMPORT_FILE_STOP_WORDS_FAILURE,
  EXPORT_FILE_STOP_WORDS_REQUEST,
  EXPORT_FILE_STOP_WORDS_SUCCESS,
  EXPORT_FILE_STOP_WORDS_FAILURE
} from 'stores/flow-type/stop-words.type';

const initialState: StopWordsState = {
  getLoading: false,
  updateLoading: false,
  success: false,
  updateSuccess: false,
  error: undefined,
  stopWords: [],
  total: 0,

  // Verify file content
  verifying: false,
  fileContentErrorCode: '',
  totalRecord: 0,

  // Import file content
  importing: false,
  totalImportedRecords: 0
};

const stopWordsReducers = (state: StopWordsState = initialState, action: StopWordsAction) => {
  switch (action.type) {
    case GET_STOP_WORDS_REQUEST:
      return { ...state, getLoading: true };
    case UPDATE_STOP_WORDS_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateSuccess: false
      };
    case GET_STOP_WORDS_SUCCESS: {
      const { data, total } = action.payload.data;
      return {
        ...state,
        getLoading: false,
        success: true,
        error: undefined,
        stopWords: [...data],
        total: total
      };
    }
    case UPDATE_STOP_WORDS_SUCCESS: {
      const { data, total } = action.payload.data;
      return {
        ...state,
        updateLoading: false,
        updateSuccess: true,
        success: true,
        error: undefined,
        stopWords: [...data],
        total
      };
    }
    case GET_STOP_WORDS_FAILURE:
    case UPDATE_STOP_WORDS_FAILURE:
      return {
        ...state,
        getLoading: false,
        updateLoading: false,
        updateSuccess: false,
        success: false,
        error: action.payload
      };

    // Verify file content
    case VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_REQUEST:
      return { ...state, success: false, verifying: true, fileContentErrorCode: '' };
    case VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        success: true,
        error: undefined,
        verifying: false,
        totalRecord: data.total,
        fileContentErrorCode: ''
      };
    }
    case VERIFY_CONTENT_BEFORE_IMPORT_STOP_WORDS_FAILURE:
      return {
        ...state,
        success: false,
        error: action.payload,
        verifying: false,
        fileContentErrorCode: action.payload.errorCode ? action.payload.errorCode : 'ORTHER'
      };

    // Import synonyms
    case IMPORT_FILE_STOP_WORDS_REQUEST:
      return {
        ...state,
        success: false,
        updateSuccess: false,
        importing: true
      };
    case IMPORT_FILE_STOP_WORDS_SUCCESS: {
      const { data: response } = action.payload;
      const totalImportedRecords = _.isArray(response.data) ? response.data.length : 0;
      return {
        ...state,
        importing: false,
        success: true,
        updateSuccess: true,
        error: undefined,
        totalImportedRecords
      };
    }
    case IMPORT_FILE_STOP_WORDS_FAILURE:
      return {
        ...state,
        importing: false,
        success: false,
        updateSuccess: false,
        error: action.payload
      };

    // Export synonyms
    case EXPORT_FILE_STOP_WORDS_REQUEST:
      return { ...state, success: false, exporting: true };
    case EXPORT_FILE_STOP_WORDS_SUCCESS: {
      return {
        ...state,
        exporting: false,
        success: true,
        error: undefined
      };
    }
    case EXPORT_FILE_STOP_WORDS_FAILURE:
      return {
        ...state,
        exporting: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default stopWordsReducers;
